import React from 'react'

import Fields from './Fields'

export default function Headers({ action, stepId }) {
  return (
    <Fields
      actionId={action.id}
      stepId={stepId}
      label="Header"
      pluralLabel="Headers"
      field="headers"
    />
  )
}
